import { render, staticRenderFns } from "./TicketInboundWhatsappMessage.vue?vue&type=template&id=4d8094a6&"
import script from "./TicketInboundWhatsappMessage.vue?vue&type=script&lang=js&"
export * from "./TicketInboundWhatsappMessage.vue?vue&type=script&lang=js&"
import style0 from "./TicketInboundWhatsappMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports